<ng-container *ngIf="!useFcpModal">
    <fc-modal [id]="modalId" [options]="options">
        <div class="fc-confirm-dialog">
            <div class="fc-confirm-dialog-title">
                <h3>{{ title | translate }}</h3>
            </div>

            <p class="fc-confirm-dialog-body">
                <ng-content></ng-content>
            </p>

            <p *ngIf="confirmationQuestion" class="fc-confirm-dialog-body">
                <strong>{{ confirmationQuestion | translate }}</strong>
            </p>

            <div class="fc-confirm-dialog-action-buttons">
                <button
                    fcp-outlined-button
                    *ngIf="options.showCancelButton"
                    (click)="onReject.emit(); close()"
                    data-e2e-hook="confirmation-request-now"
                >
                    {{ cancel | translate }}
                </button>
                <button fcp-button (click)="onAccept.emit(); close()">{{ accept | translate }}</button>
            </div>
        </div>
    </fc-modal>
</ng-container>
<ng-container *ngIf="useFcpModal">
    <fcp-modal
        title="{{ title | translate }}"
        [size]="displayMode === DisplayMode.Desktop ? ModalSizes.Small : ModalSizes.Mobile"
        [id]="modalId"
        [config]="{ id: modalId, disableClose: false }"
    >
        <div fcp-modal-content>
            {{ confirmationQuestion | translate }}
        </div>

        <div
            fcp-modal-actions
            class="fcp-modal-actions fcp-modal-actions-new"
            [ngClass]="{ 'fcp-modal-actions--mobile': displayMode === DisplayMode.Mobile }"
        >
            <button
                fcp-outlined-button
                *ngIf="options.showCancelButton"
                (click)="onReject.emit(); close()"
                data-e2e-hook="confirmation-request-now"
                class="fc-confirm-dialog-actions-button"
            >
                {{ cancel | translate }}
            </button>
            <button fcp-button (click)="onAccept.emit(); close()" class="fc-confirm-dialog-actions-button">
                {{ accept | translate }}
            </button>
        </div>
    </fcp-modal>
</ng-container>
